import type { CrudConfig } from '@/components/GenericCrudPage';

/**
 * 题组管理.
 *
 * TODO (user 后续):
 *   - 关联 Question 通过 QuestionGroupItem (M2M+排序), 需要专门拖拽排序 UI
 *   - filter_criteria 是复杂 JSON, 需要可视化筛选器
 */
export const questionGroupsConfig: CrudConfig = {
  resource: 'question-groups',
  title: '题组管理',
  rowKey: 'id',
  searchFields: ['name', 'is_active'],
  fields: [
    { name: 'id', label: 'ID', type: 'readonly', width: 80, hideInForm: true, readonly: true },
    { name: 'name', label: '题组名称', type: 'text', required: true, ellipsis: true },
    { name: 'description', label: '描述', type: 'textarea', hideInTable: true },
    { name: 'industry', label: '行业 ID', type: 'number', width: 100 },
    { name: 'shuffle_questions', label: '题目乱序', type: 'boolean', width: 110, hideInSearch: true },
    { name: 'shuffle_choices', label: '选项乱序', type: 'boolean', width: 110, hideInSearch: true },
    { name: 'time_limit_seconds', label: '限时(秒)', type: 'number', width: 110, hideInSearch: true },
    { name: 'filter_criteria', label: '筛选条件 (JSON)', type: 'json', hideInTable: true, tooltip: '动态筛选题目, 形如 {"level":3,"industry":1}' },
    { name: 'is_active', label: '启用', type: 'boolean', width: 90 },
    { name: 'created_at', label: '创建时间', type: 'datetime', width: 180, readonly: true, hideInForm: true, hideInTable: true },
  ],
};
